import { useState } from 'react';

export const useModal = (defaultOpen: boolean = false) => {
  const [isOpened, setIsOpened] = useState(defaultOpen);

  const onClose = () => {
    setIsOpened(false);
  };
  const onOpen = () => {
    setIsOpened(true);
  };

  return {
    isOpened,
    onOpen,
    onClose,
  };
};
